import {call, put, select, take, fork} from "redux-saga/effects";
import {CODES} from "../../constants";
import {getUserInfo} from "../../reducers/app";
import {recordsFilters} from "../../reducers/exchangeRecords"
import API from "../../api/api";

export function *getRecordsInfo(): Generator<any, void, any>{
	let filters = yield select(recordsFilters)
	let userInfo = yield select(getUserInfo)
	let params = {
		...filters,
		email: userInfo.email,
		clientId: 'h5'
	}
	let resp = yield call(API.getExchangeRecords, params)
	if (resp.code === CODES.SUCCESS && resp.data) {
		yield put({type: 'SET_RECORDS_INFO', payload: resp.data})
	}
}

function *getRecordsFiltersInfo(): Generator<any, void, any>{
	let filters = yield select(recordsFilters)
	let userInfo = yield select(getUserInfo)
	let params = {
		...filters,
		email: userInfo.email,
		clientId: 'h5',
		currentPage: 1,
		recordsPerPage: 20,
	}
	let resp = yield call(API.getExchangeRecords, params)
	if (resp.code === CODES.SUCCESS && resp.data) {
		yield put({type: 'SET_RECORDS_INFO', payload: resp.data})
		yield put({type: 'RESET_PAGE_INFO', payload: {currentPage: 1, recordsPerPage: 20}})
	}
}

export function *watchFiltersChange(){
	while (true) {
	    yield take('SEARCH_EXCHANGE_RECORDS')
		yield fork(getRecordsFiltersInfo)
	}
}

export function *watchExchangeIndexChange(){
	while (true) {
	    yield take('SET_PAGE_INDEX')
		yield fork(getRecordsInfo)
	}
}

export function *watchExchangeSizeChange(){
	while (true) {
	    yield take('SET_PAGE_SIZE')
		yield fork(getRecordsInfo)
	}
}

export function *watchExchangeReload(){
	while (true) {
	    yield take('RELOAD_PAGE')
		yield fork(getRecordsInfo)
	}
}
